import { FETCH_GROUPED_USERS } from '../../../helpers/constants';

export const fetchGroupedUsers = (params) => {
    return dispatch => {
        dispatch({
            type: FETCH_GROUPED_USERS,
            payload: params
        })
    }
}